<div class="per-result-sec">
    <!-- <div class="heading text-right">
        <img src="/assets/images/performance/heading.png">
    </div> -->

    <div *ngIf="!isAuthorized || perResults === null ">
        <h4>{{authorizationMsg}}</h4>
    </div>
    <div *ngIf="isAuthorized">
        <div class="d-flex">
            <a class="text-truncate ml-auto mb-1 mt-1" *ngIf="perResults.testcaseExecSumm?.loadTestType	!== 'WEB'"
							[routerLink]="['/performance/loadTesting/new-result', executedTaskId, 'queue']"
							style="padding-left: 0.2em;">Experience the redesigned results page</a>
        </div>
        <div class="perf-nav-sec">
            <div class="row mb-2" *ngIf="!testCompleted">
                <div class="col-8">
                    <label class="form-check-inline">
                        <input type="checkbox" [(ngModel)]="isAutoRefresh" (change)="setAutoRefresh();" class="mr-2">
                        Auto Refresh
                    </label>

                    <select [(ngModel)]="autoRefreshInterval" (change)="setAutoRefresh();" class="mr-2">
                        <option value="5">5 Sec</option>
                        <option value="10">10 Sec</option>
                        <option value="15">15 Sec</option>
                        <option value="30">30 Sec</option>
                        <option value="60">1 Min</option>
                    </select>

                    <i class="fas fa-sync clickable mr-2" style="font-size: 15px;" ngbTooltip="Refresh"
                        (click)="getTestcaseTopDetails()"></i>
                </div>
                <div class="col-4 text-right" *ngIf="perResults.testcaseExecSumm?.performanceRequest.parallelFlow">
                    <em> {{autoRefreshMsg()}}</em>
                    <img src="/assets/images/spin.svg" alt="spin" width="18" *ngIf="isAutoRefresh">
                </div>
                <div class="col-4 text-right" *ngIf="!perResults.testcaseExecSumm?.performanceRequest.parallelFlow">
                    <em> {{!isAutoRefresh ? 'Auto refresh is paused ' : 'Please wait test is running ..'}}</em>
                    <img src="/assets/images/spin.svg" alt="spin" width="18" *ngIf="isAutoRefresh">
                </div>
            </div>
        </div>

        <div>
            <div class="row title">
                <div class="col-6 font-bold" style="font-size:15px;">
                    <a class="fas fa-redo mr-1" *ngIf="testCompleted && !perResults.testcaseExecSumm?.performanceRequest.usingJmxFile"
                        [routerLink]="['/performance/loadTesting/rerun',perResults.testcaseExecSumm?.performanceRequest.id]"
                        ngbTooltip="Re-run"></a>
                    <a class="fas fa-redo clickable m-1 a-icon" *ngIf="testCompleted && perResults.testcaseExecSumm?.performanceRequest.usingJmxFile" [routerLink]="['/performance/loadTesting/jmx-upload', perResults.testcaseExecSumm?.performanceRequest.id]" ngbTooltip="Re-run"></a>
                    Testcase :<a [routerLink]="['/testcase/',perResults.testcaseExecSumm?.id]" target="_blank">
                        {{perResults.testcaseExecSumm?.name}}</a>
                </div>
                <div class="col-6 text-right font-bold" style="font-size:15px;"
                    *ngIf="testCompleted && (perResults.testcaseExecSumm?.loadTestType === 'API' || perResults.testcaseExecSumm?.loadTestType === 'GRAPHQL') && perResults.testcaseExecSumm?.performanceRequest?.storeResult">
                    Test Results :
                    <!-- <span class="fa fa-file-download clickable" *ngIf="perResults.testcaseExecSumm.resultFileAvailable && !perResults.testcaseExecSumm?.performanceRequest?.parallelFlow && perResults.testcaseExecSumm?.resultFileGridFsId !== null" (click)="fileDownload(perResults.testcaseExecSumm?.resultFileGridFsId)" ngbTooltip="Click to download" placement="left">
                    </span> -->
                    <span class="fa fa-file-download clickable"
                        *ngIf="perResults.testcaseExecSumm.resultFileAvailable  && perResults.testcaseExecSumm?.id !== null"
                        (click)="formalRunFileDownload(perResults.testcaseExecSumm?.id, perResults.testcaseExecSumm?.performanceRequest.id)"
                        ngbTooltip="Click to download" placement="left">
                    </span>
                </div>
                <div class="col-6 text-right" *ngIf="!testCompleted">
                    <button class="clickable btn btn-sm btn-danger" (click)="abortRunningTest()">Abort test</button>
                </div>
            </div>
        </div>

        <!-- Test Execution summary  -->
        <div class="row">
            <div class="col-12">
                <div class="custom-header">
                    <span>Test Execution summary</span>
                </div>
            </div>
            <!-- Execution summary -->
            <div class="col-12 exec-summ">
                <div class="row">
                    <div class="col pr-1">
                        <div class="box">
                            <div class="heading">
                                <img src="/assets/images/performance/active-users.png" alt=""> Peak Active Users
                            </div>
                            <div class="details">
                                {{perResults.testcaseExecSumm?.performanceRequest?.noOfUsers}}
                            </div>
                        </div>
                    </div>
                    <div class="col pr-1">
                        <div class="box">
                            <div class="heading">
                                <img src="/assets/images/performance/elapsed-time.png" alt=""> Elapsed Time (D hh:mm:ss)
                            </div>
                            <div class="details-time">
                                {{secondsToDhms(perResults.testcaseExecSumm?.elapsedTime)}}
                            </div>
                        </div>
                    </div>
                    <div class="col pr-1">
                        <div class="box">
                            <div class="heading">
                                <img src="/assets/images/performance/total-hits.png" alt="">
                                {{perResults.testcaseExecSumm?.loadTestType === 'WEB' ? 'Total Transactions' : 'Total
                                Hits'}}
                            </div>
                            <div class="details">
                                {{perResults.testcaseExecSumm?.noOfHits || 0}}
                            </div>
                        </div>
                    </div>
                    <div class="col pr-1">
                        <div class="box">
                            <div class="heading" *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'">
                                <img src="/assets/images/performance/hits-per-second.png" alt=""> Hits Per Second
                            </div>
                            <div class="heading" *ngIf="perResults.testcaseExecSumm?.loadTestType === 'WEB'">
                                <img src="/assets/images/performance/hits-per-second.png" alt="">
                                {{perResults.testcaseExecSumm?.loadTestType === 'WEB' ? 'Transaction Per Second' :
                                'Transaction Hits Per Second'}}
                            </div>
                            <div class="details">
                                {{perResults.testcaseExecSumm?.hitsPerSec.toFixed(2) || 0}}
                            </div>
                        </div>
                    </div>
                    <div class="col pr-1">
                        <div class="box throughput">
                            <div class="heading">
                                <img src="/assets/images/performance/throughput.png" alt=""> Throughput (Tps)
                            </div>
                            <div class="details">
                                {{perResults.testcaseExecSumm?.throughput}}
                            </div>
                        </div>
                    </div>
                    <div class="col pr-1">
                        <div class="box">
                            <div class="heading">
                                <img src="/assets/images/performance/total-hits.png" alt=""> Network Received(Kbps)
                            </div>
                            <div class="details">
                                {{perResults.testcaseExecSumm?.receivedKbPerSecond}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- LoadTest Details -->
            <div class="col-12 additional-info mb-3">
                <div class="loadtest-details">
                    <span>LoadTest Details </span>
                    <i class="float-right fas clickable"
                        [ngClass]="loadTestDataDetails ? 'fa-chevron-circle-down' : 'fa-chevron-circle-up'"
                        (click)="loadTestDataDetails = !loadTestDataDetails"></i>
                </div>
                <div class="queue-table table-responsive" [hidden]="loadTestDataDetails">
                    <div class="col-12">
                        <label>Comments</label>
                        <div class="threadgroupDesc">
                            {{perResults.testcaseExecSumm?.performanceRequest.comments ?
                            perResults.testcaseExecSumm?.performanceRequest.comments : 'No Comments Added'}}
                        </div>
                    </div>
                </div>
            </div>

            <!-- exception -->
            <div class="row" *ngIf="perResults.testcaseExecSumm?.performanceRequest.exceptionOccurred">
                <div class="col-md-12">
                    {{perResults.testcaseExecSumm?.performanceRequest.exceptionMessage}}
                </div>
            </div>

            <!-- additional info -->
            <div class="col-12 mb-1 additional-info" style="display: flex;">
                <div class="col-3">
                    <label>Location : </label> {{perResults.testcaseExecSumm?.performanceRequest.location}}
                </div>
                <div class="col-3" *ngIf="perResults.testcaseExecSumm?.performanceRequest.iteration;else duration">
                    <label>Iteration :</label> {{perResults.testcaseExecSumm?.performanceRequest.iterationCount}}
                </div>
                <ng-template #duration>
                    <div class="col-3">
                        <label>Duration (D hh:mm:ss) :</label>
                        {{secondsToDhms(perResults.testcaseExecSumm?.performanceRequest.durationInSec)}}
                    </div>
                </ng-template>

                <div class="col-2">
                    <label>Testcase Type : </label> {{perResults.testcaseExecSumm?.performanceRequest.loadTestType}}
                </div>
                <div class="col">
                    <label>Executed By : </label> {{perResults.testcaseExecSumm?.executedBy}}
                </div>
            </div>

            <div class="col-12 additional-info" style="display: flex;">
                <div class="col-3">
                    <label>Start Time (PST) : </label>
                    {{perResults.testcaseExecSumm?.performanceRequest.startTime | date: 'd-MM-yy, hh:mm:ss a' }}
                </div>
                <div class="col-3">
                    <label>End Time (PST): </label>
                    {{perResults.testcaseExecSumm?.performanceRequest.endTime | date: 'd-MM-yy, hh:mm:ss a'}}
                </div>
                <div class="col text-truncate"><label> Environment : </label> <span
                        title="{{perResults.testcaseExecSumm?.performanceRequest.environmentMap?.name}}">
                        {{perResults.testcaseExecSumm?.performanceRequest.environmentMap?.name}}</span></div>
            </div>

            <div class="col-12 additional-info" style="display: flex;"
                *ngIf="perResults.testcaseExecSumm?.performanceRequest.errorMessage !== null">
                <div class="col" style="display: flex;">
                    <div style="color: red; margin: 1px; font-size: 20px;">
                        {{perResults.testcaseExecSumm?.performanceRequest.errorMessage}} </div>
                </div>
            </div>

            <!-- Response Summary -->
            <div class="col-12 mb-3">
                <div class="loadtest-details">
                    <span>Response Summary </span>
                    <i class="float-right fas clickable"
                        [ngClass]="responseSummary ? 'fa-chevron-circle-down' : 'fa-chevron-circle-up'"
                        (click)="responseSummary = !responseSummary"></i>
                </div>
                <div [hidden]="responseSummary">
                    <!-- Table -->
                    <div *ngIf="queueRes.length > 0">
                        <div class="queue-table table-responsive">
                            <table class="table table-sm table-borderless">
                                <thead>
                                    <tr>
                                        <th rowspan="2" class="text-center" width="1%"
                                            *ngIf="perResults.testcaseExecSumm?.loadTestType === 'WEB'"></th>
                                        <th rowspan="2" class="text-center" width="10%"
                                            (click)="sortByColumn('sequence')"
                                            *ngIf="perResults.testcaseExecSumm?.loadTestType === 'WEB'">Selected
                                            Endpoints</th>
                                        <th rowspan="2" class="text-center" width="10%" (click)="sortByColumn('name')"
                                            *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'">Selected
                                            Endpoints</th>
                                        <!-- <th rowspan="2" class="text-center" width="7%">User Load</th> -->
                                        <th rowspan="2" class="text-center" width="8%"
                                            (click)="sortByColumn('noOfHits')">
                                            {{perResults.testcaseExecSumm?.loadTestType === 'WEB' ? 'Total Transactions'
                                            : 'Total Hits'}}
                                        </th>
                                        <th rowspan="2" class="text-center" width="8%"
                                            (click)="sortByColumn('passedHits')">
                                            {{perResults.testcaseExecSumm?.loadTestType === 'WEB' ? 'Passed
                                            Transactions' : 'Passed Hits'}}
                                        </th>
                                        <th rowspan="2" class="text-center" width="5%"
                                            (click)="sortByColumn('errorCount')">Failed Hits</th>
                                        <th rowspan="2" class="text-center" width="9%"
                                            *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'"
                                            (click)="sortByColumn('hitsPerSecond')">Hits/sec</th>
                                        <th rowspan="2" class="text-center" width="9%"
                                            *ngIf="perResults.testcaseExecSumm?.loadTestType === 'WEB'"
                                            (click)="sortByColumn('hitsPerSecond')">
                                            {{perResults.testcaseExecSumm?.loadTestType === 'WEB' ? 'Transaction Per
                                            Second' : 'Transaction Hits Per Second'}}
                                        </th>
                                        <th rowspan="2" class="text-center" width="5%"
                                            (click)="sortByColumn('minResponse')">Min</th>
                                        <th rowspan="2" class="text-center" width="5%"
                                            (click)="sortByColumn('maxResponse')">Max</th>
                                        <th rowspan="2" class="text-center" width="9%"
                                            (click)="sortByColumn('ninetyPercentile')">90%</th>
                                        <th colspan="2" class="text-center" width="7%"
                                            *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'">Res. Time(sec)
                                        </th>
                                        <th rowspan="2" class="text-center" width="10%"
                                            *ngIf="perResults.testcaseExecSumm?.loadTestType === 'WEB'"
                                            (click)="sortByColumn('avgResponse')">Avg. Res. Time(sec)</th>
                                        <th rowspan="2" class="text-center" width="5%"
                                            *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'"
                                            (click)="sortByColumn('throughput')">Throughput (Tps)</th>
                                        <th colspan="2" class="text-center" width="7%"
                                            *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'">Network(Kbps)
                                        </th>
                                        <th rowspan="2" class="text-center" width="13%"
                                            (click)="sortByColumn('status')">Result</th>
                                    </tr>
                                    <tr>
                                        <th class="text-center" width="7%"
                                            *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'"
                                            (click)="sortByColumn('sla')">Exp.</th>
                                        <th class="text-center" width="7%"
                                            *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'"
                                            (click)="sortByColumn('actualSla')">Act.</th>
                                        <th class="text-center" width="7%"
                                            *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'"
                                            (click)="sortByColumn('receivedKbPerSecond')">Received</th>
                                        <th class="text-center" width="7%"
                                            *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'"
                                            (click)="sortByColumn('sentKbPerSecond')">Sent</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let queueRes of queueRes">
                                        <tr class="clickable text-center" ngbTooltip="Click for more details"
                                            (click)="queueRes.failedSamplesCollapsed = !queueRes.failedSamplesCollapsed">
                                            <td class="text-left"
                                                *ngIf="perResults.testcaseExecSumm?.loadTestType === 'WEB'">
                                                {{queueRes.sequence}}.</td>
                                            <td class="text-left wrap">
                                                <span triggers="mouseenter:mouseleave"
                                                    [ngbPopover]="perResults.testcaseExecSumm?.loadTestType !== 'WEB'? EndpointPopContent : null"
                                                    placement="right">
                                                    {{queueRes.name}}
                                                </span>
                                                <ng-template #EndpointPopContent>
                                                    <div style="font-size:11.5px;color:#000">
                                                        <div><strong>Think Time :
                                                            </strong>{{queueRes.loadTestEndPointConfigDto?.think_time ||
                                                            queueRes.loadTestEndPointConfigDto?.think_time === 0 ?
                                                            queueRes.loadTestEndPointConfigDto?.think_time : 'NA'}}
                                                        </div>
                                                        <div><strong>Data file Name :
                                                            </strong>{{queueRes.loadTestEndPointConfigDto?.fileInfo?.fileName
                                                            ? queueRes.loadTestEndPointConfigDto?.fileInfo?.fileName :
                                                            'NA'}}</div>
                                                    </div>
                                                </ng-template>
                                            </td>
                                            <!-- <td>{{queueRes?.noOfUsers}}</td> -->
                                            <td>{{queueRes.noOfHits}}</td>
                                            <td>{{queueRes.passedHits}}</td>
                                            <td>{{queueRes.errorCount}}</td>
                                            <td>{{queueRes?.hitsPerSecond?.toFixed(2)}}</td>
                                            <td>{{queueRes.minResponse || 'NA'}}</td>
                                            <td>{{queueRes.maxResponse || 'NA'}}</td>
                                            <td>{{queueRes.ninetyPercentile || 'NA'}} <i class="fas fa-info-circle ml-1"
                                                    triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"></i>
                                            </td>
                                            <td *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'">
                                                {{queueRes.sla}}</td>
                                            <td *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'">
                                                {{queueRes.actualSla}}</td>
                                            <td *ngIf="perResults.testcaseExecSumm?.loadTestType === 'WEB'">
                                                {{queueRes.avgResponse}}</td>
                                            <td *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'">
                                                {{queueRes?.throughput}}</td>
                                            <td *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'">
                                                {{queueRes?.receivedKbPerSecond}}</td>
                                            <td *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'">
                                                {{queueRes?.sentKbPerSecond}}</td>
                                            <td [ngSwitch]="queueRes.status" class="text-center">
                                                <div *ngSwitchCase="'PASSED'" class="pass">
                                                    <img src="/assets/images/performance/completed.png" width="20px"
                                                        alt="PASSED" ngbTooltip="Passed" placement="bottom">
                                                </div>
                                                <div *ngSwitchCase="'FAILED'" class="fail">
                                                    <img src="/assets/images/performance/failed.png" width="20px"
                                                        alt="FAILED"
                                                        ngbTooltip="{{(queueRes.actualSla > queueRes.sla) && queueRes.errorCount === 0 ? 'Failed: SLA Breach':'Failed'}}"
                                                        placement="bottom">
                                                </div>
                                                <div *ngSwitchCase="'ABORTED'" class="in-review">
                                                    <img src="/assets/images/performance/abort2.png" width="20px"
                                                        alt="ABORTED" ngbTooltip="Aborted" placement="bottom">
                                                </div>
                                                <div class="text-center" *ngSwitchDefault>
                                                    <img src="/assets/images/spin.svg" width="18">
                                                </div>
                                            </td>
                                            <ng-template #popContent1>
                                                <div style="font-size:11.5px;color:#000">
                                                    <div><strong>50% : </strong>{{queueRes.fiftyPercentile || 'NA'}}
                                                    </div>
                                                    <div><strong>80% : </strong>{{queueRes.eightyPercentile || 'NA'}}
                                                    </div>
                                                    <div><strong>90% : </strong>{{queueRes.ninetyPercentile || 'NA'}}
                                                    </div>
                                                    <div><strong>95% : </strong>{{queueRes.ninetyFivePercentile ||
                                                        'NA'}}</div>
                                                    <div><strong>99% : </strong>{{queueRes.ninetyNinePercentile ||
                                                        'NA'}}</div>
                                                </div>
                                            </ng-template>
                                            <ng-template #failedTooltipContent>
                                                <div>Failed <span *ngIf="queueRes.errorMessage"> :
                                                        {{queueRes.errorMessage}}</span></div>
                                            </ng-template>
                                        </tr>
                                        <tr class="text-center"
                                            [ngbCollapse]="!queueRes.failedSamplesCollapsed || queueRes.performanceWebInstructionDtos === null"
                                            *ngFor="let webInstruction of queueRes.performanceWebInstructionDtos; let i=index">
                                            <td class="text-left">{{i}}.</td>
                                            <td class="text-left wrap">{{webInstruction.name}}</td>
                                            <td>{{webInstruction.totalHits}}</td>
                                            <td>{{webInstruction.passedHits}}</td>
                                            <td>{{webInstruction.failedHits}}</td>
                                            <td>{{webInstruction.hitsPerSecond.toFixed(2)}}</td>
                                            <td>{{webInstruction.minResponseTime}}</td>
                                            <td>{{webInstruction.maxResponseTime}}</td>
                                            <td>{{webInstruction.ninetyPercentile || 'NA'}} <i
                                                    class="fas fa-info-circle ml-1" triggers="mouseenter:mouseleave"
                                                    [ngbPopover]="popContent2"></i></td>
                                            <td>{{webInstruction.avgResponseTime}}</td>
                                            <td [ngSwitch]="webInstruction.executionStatus">
                                                <div *ngSwitchCase="'PASSED'" class="pass">
                                                    <img src="/assets/images/performance/completed.png" width="20px"
                                                        alt="PASSED" ngbTooltip="Passed" placement="bottom">
                                                </div>
                                                <div *ngSwitchCase="'FAILED'" class="fail">
                                                    <img src="/assets/images/performance/failed.png" width="20px"
                                                        alt="FAILED" ngbTooltip="Failed" placement="bottom">
                                                </div>
                                                <div *ngSwitchCase="'ABORTED'" class="in-review">
                                                    <img src="/assets/images/performance/abort2.png" width="20px"
                                                        alt="ABORTED" ngbTooltip="Aborted" placement="bottom">
                                                </div>
                                                <div class="text-center" *ngSwitchDefault>
                                                    <img src="/assets/images/spin.svg" width="18">
                                                </div>
                                            </td>
                                            <ng-template #popContent2>
                                                <div style="font-size:11.5px;color:#000">
                                                    <div><strong>50% : </strong>{{webInstruction.fiftyPercentile ||
                                                        'NA'}}</div>
                                                    <div><strong>80% : </strong>{{webInstruction.eightyPercentile ||
                                                        'NA'}}</div>
                                                    <div><strong>90% : </strong>{{webInstruction.ninetyPercentile ||
                                                        'NA'}}</div>
                                                    <div><strong>95% : </strong>{{webInstruction.ninetyFivePercentile ||
                                                        'NA'}}</div>
                                                    <div><strong>99% : </strong>{{webInstruction.ninetyNinePercentile ||
                                                        'NA'}}</div>
                                                </div>
                                            </ng-template>
                                        </tr>

                                        <tr [ngbCollapse]="!queueRes.failedSamplesCollapsed">
                                            <td colspan="11" *ngIf="!queueRes.failedSamples">
                                                <p>No failed records</p>
                                            </td>
                                            <td colspan="11" *ngIf="queueRes.failedSamples">
                                                <div class="row font-bold">
                                                    <div class="col-1">Count</div>
                                                    <div class="col-2">Code</div>
                                                    <div class="col-3">Message</div>
                                                    <div class="col-6">URL</div>
                                                </div>
                                                <div class="row" *ngFor="let failedSample of queueRes.failedSamples">
                                                    <div class="col-1">{{failedSample.count}}</div>
                                                    <div class="col-2 relay-word-wrap">{{failedSample.code}}</div>
                                                    <div class="col-3 relay-word-wrap">{{failedSample.message}}</div>
                                                    <div class="col-6 relay-word-wrap">{{failedSample.url}}</div>
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-container>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <app-system-stats [machineList]=machineStats [appPermission]="[ADMIN,SUPER_ADMIN]"></app-system-stats>
            </div>

        </div>

        <div class="row">

            <!-- Graphs -->
            <div class="col-12 mt-n2">
                <div class="chart-section">
                    <div class="loadtest-details">
                        <span>Charts summary</span>
                        <i class="float-right fas clickable"
                            [ngClass]="chartsSummary ? 'fa-chevron-circle-down' : 'fa-chevron-circle-up'"
                            (click)="chartsSummary = !chartsSummary"></i>
                    </div>
                    <div class="row" [hidden]="chartsSummary">
                        <div class="col-md-6 col-sm-12">
                            <div class="chart-box">
                                <h5 class="title one">Running Vusers</h5>
                                <canvas id="trendChart" ngChartjs [datasets]="length > 0 ? dataUsers : dataVUsers"
                                    [labels]="labelsAvgTRes" [chartType]="lineChartType" [options]="optionsUsers"
                                    [legend]=false [colors]="colors"></canvas>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <div class="chart-box">
                                <h5 class="title two">Number of Hits Achieved
                                </h5>
                                <canvas ngChartjs [datasets]="dataHitsPSec" [labels]="labelsAvgTRes"
                                    [chartType]="lineChartType" [options]="optionsHitsPSec" [legend]=false
                                    [colors]="colors"></canvas>
                            </div>
                        </div>
                        <div class="w-100"></div>
                        <div class="col-md-6 col-sm-12">
                            <div class="chart-box">
                                <h5 class="title three">Throughput (Kbps)</h5>
                                <canvas ngChartjs [datasets]="dataThroughput" [labels]="labelsAvgTRes"
                                    [chartType]="lineChartType" [options]="optionsThroughput" [legend]=false
                                    [colors]="colors"></canvas>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <div class="chart-box">
                                <h5 class="title four">Average Response Time</h5>
                                <canvas ngChartjs [datasets]="dataAvgTRes" [labels]="labelsAvgTRes"
                                    [chartType]="lineChartType" [options]="optionsAvgTRes" [legend]=false
                                    [colors]="colors"></canvas>
                            </div>
                        </div>
                        <div class="w-100"></div>
                        <div class="col-6">
                            <div class="chart-box">
                                <h5 class="title four">Error Count</h5>
                                <canvas ngChartjs [datasets]="dataErrorCount" [labels]="labelsAvgTRes"
                                    [chartType]="lineChartType" [options]="optionsErrorCount" [legend]=false
                                    [colors]="colors"></canvas>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>